module.exports = __webpack_public_path__ + "media/media/tooltips/version-5697a8889da0833e409474d7d97b9c8e.jpg";